export default __webpack_public_path__ + "static/media/penydrop.000bf640.png";